import { AnyAction } from '@reduxjs/toolkit'

import { PayloadActionWithError } from './PayloadActionWithError'

export const isClearAll =
  () =>
  (action: AnyAction): action is PayloadActionWithError =>
    action.type === 'clearAll'
